import type { BasicInfoProps, LookalikeSegmentProps, PricedSegmentProps } from './types.ts';

export const isPricedSegmentProps = (props: BasicInfoProps): props is PricedSegmentProps => {
  return props.priced && !props.isLookalike;
};

export const isLookalikeSegmentProps = (props: BasicInfoProps): props is LookalikeSegmentProps => {
  return props.isLookalike;
};
